import { render, staticRenderFns } from "./submitPlayer.vue?vue&type=template&id=00010810&scoped=true&"
import script from "./submitPlayer.vue?vue&type=script&lang=js&"
export * from "./submitPlayer.vue?vue&type=script&lang=js&"
import style0 from "./submitPlayer.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./submitPlayer.vue?vue&type=style&index=1&id=00010810&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00010810",
  null
  
)

export default component.exports